import React, { useState, ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';
import { info_fill, success_fill, warning_fill, error_fill, close } from '@shared/assets/svg/base';
import classNames from 'classnames';
import styles from './index.module.less';

export interface AlertProps {
	style?: React.CSSProperties;
	className?: string;
	/** 自定义右侧操作项 */
	action?: ReactNode;
	closable?: boolean;
	onClose?: (e: any) => void;
	afterClose?: () => void;
	type?: 'info' | 'success' | 'warning' | 'error';
	content?: ReactNode;
	icon?: ReactNode;
	/** 自定义关闭按钮 */
	closeElement?: ReactNode;
	showIcon?: boolean;
	customSuffixElement?: ReactNode;
}

export function BaseAlert(props: AlertProps) {
	const {
		style,
		className,
		action,
		type = 'info',
		content,
		icon,
		showIcon = true,
		closable,
		afterClose,
		onClose,
		closeElement,
		customSuffixElement,
		...rest
	} = props;

	const [visible, setVisible] = useState<boolean>(true);

	const ALERT_TYPE = {
		info: info_fill,
		success: success_fill,
		warning: warning_fill,
		error: error_fill,
	};

	function onHandleClose(e: any) {
		setVisible(false);
		onClose?.(e);
	}

	return (
		<CSSTransition
			in={visible}
			timeout={300}
			classNames="zoomInTop"
			unmountOnExit
			onExited={() => {
				afterClose?.();
			}}
		>
			<div
				style={style}
				className={classNames(styles.alert, styles[`alert_${type}`], className)}
				role="alert"
				{...rest}
			>
				{showIcon && (
					<NewBaseIcon
						icon={ALERT_TYPE[type]}
						className={styles.icon_wrapper}
						size={20}
					></NewBaseIcon>
				)}
				<div className={styles.alert_content_wrapper}>
					{content && <div className={styles.alert_content}>{content}</div>}
				</div>
				{action && <div className={styles.alert_action}>{action}</div>}
				{closable && (
					<div onClick={onHandleClose} className={styles.alert_close_btn}>
						{closeElement || <NewBaseIcon icon={close} />}
					</div>
				)}
				{customSuffixElement && (
					<div className={styles.custom_suffix_element}>{customSuffixElement}</div>
				)}
			</div>
		</CSSTransition>
	);
}
